var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";

var Col = function Col(_ref) {
  var xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      offsetXs = _ref.offsetXs,
      offsetSm = _ref.offsetSm,
      offsetMd = _ref.offsetMd,
      offsetLg = _ref.offsetLg,
      offsetXl = _ref.offsetXl,
      first = _ref.first,
      last = _ref.last,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["xs", "sm", "md", "lg", "xl", "offsetXs", "offsetSm", "offsetMd", "offsetLg", "offsetXl", "first", "last", "className", "children"]);

  return React.createElement(
    "div",
    _extends({
      className: [xs === true ? "col-xs" : "", sm === true ? "col-sm" : "", md === true ? "col-md" : "", lg === true ? "col-lg" : "", xl === true ? "col-xl" : "", typeof xs === "number" ? "col-xs-" + xs : "", typeof sm === "number" ? "col-sm-" + sm : "", typeof md === "number" ? "col-md-" + md : "", typeof lg === "number" ? "col-lg-" + lg : "", typeof xl === "number" ? "col-xl-" + xl : "", typeof offsetXs === "number" ? "col-xs-offset-" + offsetXs : "", typeof offsetSm === "number" ? "col-sm-offset-" + offsetSm : "", typeof offsetMd === "number" ? "col-md-offset-" + offsetMd : "", typeof offsetLg === "number" ? "col-lg-offset-" + offsetLg : "", typeof offsetXl === "number" ? "col-xl-offset-" + offsetXl : "", first ? typeof first !== "boolean" && "first-" + first || "first-xs" : "", last ? typeof last !== "boolean" && "last-" + last || "last-xs" : "", className || ""].filter(function (c) {
        return c !== "";
      }).join(" ")
    }, props),
    children
  );
};

Col.propTypes = {
  xs: PropTypes.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sm: PropTypes.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  md: PropTypes.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  lg: PropTypes.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  xl: PropTypes.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  offsetXs: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  offsetSm: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  offsetMd: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  offsetLg: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  offsetXl: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  first: PropTypes.oneOf([true, false, "xs", "sm", "md", "lg"]),
  last: PropTypes.oneOf([true, false, "xs", "sm", "md", "lg"])
};

Col.defaultProps = {
  xs: true,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  offsetXs: null,
  offsetSm: null,
  offsetMd: null,
  offsetLg: null,
  offsetXl: null,
  first: false,
  last: false
};

export default Col;